import dayjs from 'dayjs';

export const isToday = (dateISOString: string): boolean => {
  if (!dayjs(dateISOString).isValid()) return false;

  const today = dayjs().toDate().toLocaleDateString();

  const integerDateDiff = dayjs(today).diff(
    dayjs(dateISOString),
    'date',
    false,
  );

  return integerDateDiff == 0;
};

export const isBeforeToday = (dateISOString: string): boolean => {
  if (!dayjs(dateISOString).isValid()) return false;

  const today = dayjs().toDate().toLocaleDateString();

  const integerDateDiff = dayjs(today).diff(
    dayjs(dateISOString),
    'date',
    false,
  );

  return integerDateDiff > 0;
};

export const isAfterToday = (dateISOString: string): boolean => {
  if (!dayjs(dateISOString).isValid()) return false;

  const today = dayjs().toDate().toLocaleDateString();

  const integerDateDiff = dayjs(today).diff(
    dayjs(dateISOString),
    'date',
    false,
  );

  return integerDateDiff < 0;
};
